<ng-container *ngIf="textKey">
  <div
    class="bg-white"
    *ngIf="showWarningBar">
    <div
      class="relative bg-sun-yellow bg-opacity-20 text-magenta text-center px-4 font-bold py-1 ">
      <div
        class="cursor-pointer hover:underline hover:text-opacity-50 hover:scale-[101%] transition transform ease-in-out"
        [routerLink]="url"
        [queryParams]="queryParams">
        {{textKey | transloco}}
      </div>
      <mat-icon
        class="absolute top-1 right-1 text-blue1 cursor-pointer hover:text-blue2 transition transform ease-in-out"
        (click)="hideHeader()">close
      </mat-icon>
    </div>
  </div>

</ng-container>
